module.exports = __webpack_public_path__ + "img/1.fa5c67fd.png";